<template>
    <el-dialog
        class="seeoffer-dailog-style"
        title="报价"
        v-dialogDrag
        :width="'1000px'"
        :visible.sync="seeOfferVisible"
        :before-close="close"
        :append-to-body="true"
    >
        <div class="offer-bid-dialog">
            <div  class="bid-dialog-table">
                <el-table :data="dataList" height="400">
                    <el-table-column
                        v-for="(item, i) in column"
                        :key="i"
                        :prop="item.prop"
                        :label="item.label"
                    ></el-table-column>
                </el-table>
            </div>

            <div class="bid-dialog-pop">
                <div>
                    <span class="content-desc-item">倒计时:<span class="count-down">{{countTimes}}</span></span>
                </div>
                <div class="text-ipt">
                    <el-radio-group v-model="resource" class="grp-box">
                        <el-radio label="按比例"></el-radio>
                        <el-radio label="按数值"></el-radio>
                    </el-radio-group>
                    <div class="content-box-item">
                        <div class="notice_title">{{ resource | setVal }}</div>
                        <el-input-number class="tab-width" size="mini" controls-position="right"  v-model.trim="priceReducationValue"  :min="0">
                        </el-input-number>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit" :loading="loading">报 价</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { realTimeBiddingList, getCountDown, publishBidding } from '../../../api/tenderDetails.js';
const BID_RANK_VISIBLE = {
    NO: '2', // 否
    PRICE: '3', // 价格分排名
    MULTIPLE: '3' // 综合分排名
};
export default {
    props: {
        seeOfferVisible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tenderCode: {
            type: String,
            default() {
                return '';
            }
        },
        bidNo: {
            type: String,
            default() {
                return '';
            }
        },
        managementSide: {
            type: Boolean,
            default() {
                return false;
            }
        },
        currentList: {
            type: Array,
            default() {
                return [];
            }
        },
        currentTime: [String, Number],
        rankVisible: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            loading: false,
            setIntervalTime: null,
            resource: '按比例',
            priceReductionType: '1',
            priceReducationValue: '',
            offerVisible: false,
            countTimes: '',
            dataList: [],
            cuuntdownSeconds: '',
            column: [
                {
                    label: '标段',
                    prop: 'extStr1'
                },
                {
                    label: '总费用',
                    prop: 'lineAmountTotal'
                },
                {
                    label: '当前最低价',
                    prop: 'currentLowestPrice'
                }
                // {
                //     label: '当前排名',
                //     prop: 'currentRank'
                // }
            ]
        };
    },
    beforeDestroy() {
        this.setIntervalTime && clearTimeout(this.setIntervalTime);
    },
    methods: {
        getCountDownFunc() {
            getCountDown({ tenderCode: this.$route.query.tenderCode }).then(res => {
                if (res && res.code === '0') {
                    if (res.data <= 0) {
                        this.countTimes = '已截止';
                        this.$emit('showTenderStatus', 0);
                        clearTimeout(this.setIntervalTime);
                        return;
                    }
                    this.cuuntdownSeconds = res.data / 1000;
                    this.setCountTime();
                }
            });
        },
        setCountTime() {
            this.setIntervalTime = setTimeout(() => {
                this.cuuntdownSeconds--;
                this.countTimes = this.countTimeSet(this.cuuntdownSeconds);
                if (this.cuuntdownSeconds <= 0) {
                    this.countTimes = '已截止';
                    this.$emit('showTenderStatus', 0);
                    this.setIntervalTime && clearTimeout(this.setIntervalTime);
                    return;
                }
                this.setCountTime();
            }, '1000');
        },
        countTimeSet(time) {
            const hour = Math.floor(time / 60 / 60) < 10 ? '0' + Math.floor(time / 60 / 60) : Math.floor(time / 60 / 60);
            const minutes = Math.floor(time / 60 % 60) < 10 ? '0' + Math.floor(time / 60 % 60) : Math.floor(time / 60 % 60);
            const seconds = Math.floor(time % 60) < 10 ? '0' + Math.floor(time % 60) : Math.floor(time % 60);
            return hour + ':' + minutes + ':' + seconds;
        },
        close() {
            this.$emit('update:seeOfferVisible', false);
        },
        realTimeBiddingListFunc() {
            const par = {
                bidNo: this.bidNo, // 标书编号
                tenderCode: this.tenderCode, // 报价轮次编号
                supplierCode: this.$store.state.supplier ? this.$store.state.supplier.supplierCode : '', // 供应商编码 (管理端不用传该参数， 供应商端必传)
                portal: !this.managementSide // 供应商端传true，管理端传false
            };
            realTimeBiddingList(par).then((res) => {
                if (res && res.code === '0') {
                    this.dataList = res.data || [];
                }
            });
        },
        submit() {
            if (!this.priceReducationValue) {
                this.$message.warning('请输入降幅数值！');
                return;
            }
            if (this.priceReductionType === '按比例' && this.priceReducationValue > 100) {
                this.$message.warning('降幅比例不能大于100%！');
                return;
            }
            this.loading = true;
            const par = {
                bidNo: this.bidNo,
                tenderCode: this.tenderCode,
                supplierCode: this.$store.state.supplier.supplierCode,
                priceReductionType: this.resource === '按比例' ? '1' : '2',
                priceReducationValue: this.priceReducationValue
            };
            publishBidding(par).then((res) => {
                this.loading = false;
                if (res && res.code === '0') {
                    this.priceReducationValue = '';
                    this.$message.success('报价成功！');
                    this.$emit('update:offerVisible', false);
                }
            });
        }
    },
    filters: {
        setVal(val) {
            if (val === '按比例') {
                return '降幅比例（%）';
            } else {
                return '降幅数值（元）';
            }
        }
    },
    watch: {
        seeOfferVisible(val) {
            if (val) {
                this.setIntervalTime && clearTimeout(this.setIntervalTime);
                this.realTimeBiddingListFunc();
                this.getCountDownFunc();
                if (this.rankVisible !== BID_RANK_VISIBLE['NO']) {
                    this.column.push({
                        label: '当前排名',
                        prop: 'currentRank'
                    });
                }
            }
        },
        currentList(val) {
            this.setIntervalTime && clearTimeout(this.setIntervalTime);
            this.dataList = val;
            this.cuuntdownSeconds = this.currentTime;
            this.setCountTime();
        }
    }
};
</script>
<style lang="less">
.seeoffer-dailog-style {
    .operate-btn {
        margin-bottom: 10px;
    }
    .content-desc-item {
        margin-bottom: 4px;
        width: 33.3%;
        color: #888888;
        font-size: 14px;
    }
    .count-down {
        margin-left: 5px;
        color: #FF7C24;
        font-size: 18px;
        font-weight: 700;
    }
    .count-box {
        display: flex;
        justify-content: space-between;
    }
    .offer-bid-dialog {
        display: flex;

    }
    .el-dialog__body {
        padding: 0;
    }
    .bid-dialog-table {
        padding: 15px;
        width: 100%;
    }
    .bid-dialog-pop {
        width: 435px;
        border-left: 1px solid #e6e6e6;
        padding: 15px;
    }
    .el-dialog__footer {
        border-top: 1px solid #e6e6e6;
    }
    .content-box-item {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 15px;
    }
    .notice_title {
        font-size: 12px;
        flex-shrink: 0;
        display: flex;
        justify-content: flex-end;
    }
    .tab-width {
        width: 120px;
    }
    .text-ipt {
        margin-top: 30px;
    }
}
</style>